import * as Yup from 'yup';

export enum UploadStatus {
  Pending = 'pending',
  Finding = 'finding',
  Compressing = 'compressing',
  Uploading = 'uploading',
  Uploaded = 'uploaded',
  Processing = 'processing',
  Completed = 'completed',
  UploadFailed = 'upload_failed',
  ProcessingFailed = 'processing_failed',
}

export const isFailedStatus = (status: UploadStatus): boolean =>
  status === UploadStatus.UploadFailed || status === UploadStatus.ProcessingFailed;

export const isTerminalStatus = (status: UploadStatus): boolean =>
  status === UploadStatus.Completed || isFailedStatus(status);

export enum UploadTrigger {
  Scheduled = 'scheduled',
  Manual = 'manual',
  Remote = 'remote',
}

export const UploadSchema = Yup.object().shape({
  store_id: Yup.string().required(),
  upload_id: Yup.string().required(),

  trigger: Yup.mixed<UploadTrigger>().oneOf(Object.values(UploadTrigger)).defined().required(),
  status: Yup.mixed<UploadStatus>().oneOf(Object.values(UploadStatus)).defined().required(),

  machine_id: Yup.string().defined(),
  s3_key: Yup.string().optional(),
  error_message: Yup.string().optional(),

  started_at: Yup.date().required(),
  upload_finished_at: Yup.date().optional(),
  processing_started_at: Yup.date().optional(),
  updated_at: Yup.date().required(),
});

export type Upload = Yup.InferType<typeof UploadSchema>;
